<ng-template [ngIf]="isLoadingResults">
  <app-loading></app-loading>
</ng-template>
  <button pButton pRipple icon="pi pi-plus" [disabled]="isNuovaNota || isDemo " (click)="aggiungiNota()" label="AGGIUNGI" class="mt-1 mb-1 p-button-outlined font-['Poppins']"
  style="color: #2B4162; background-color: #BFEA7C; border-color: #2B4162;"></button>
  <button *ngIf="isNuovaNota"  [disabled]="aggiungiNotaForm.invalid" pButton pRipple icon="pi pi-save"  (click)="salvaNota()" label="SALVA" class="ml-2 mb-1 p-button-outlined font-['Poppins']"
    style="color: #ffffff; background-color: #24945a; border-color: #061833;"></button>
    
  <div *ngIf="isNuovaNota" class="mb-3 mt-2" >
    <p-card >
      <ng-template pTemplate="title">
        <div class="note-header flex justify-between items-center">
          <div >
              <strong >NUOVA NOTA</strong>           
            </div>         
      </div>
  
      </ng-template>
      <ng-template pTemplate="content">
        <form [formGroup]="aggiungiNotaForm">
          <textarea style="width: 100%;" id="note" rows="5" formControlName="contenuto" [autoResize]="true" pInputTextarea>  </textarea>
        </form>
      </ng-template>
    </p-card>
  </div>
 

 
<div *ngFor="let nota of listaNote" class="mb-3">
  <p-card >
      <ng-template pTemplate="title">
        <div class="note-header flex justify-between items-center">
          <div class="flex items-center">
            <strong *ngIf="nota.utente">CREATA DA {{ nota.utente.nome }} IL</strong> 
              <span class="text-gray ml-2">{{utilService.formattaDataDaDate(nota.data) }}</span>
          </div>
          <!-- <div class="flex" style="align-items: end;">
            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-text p-button-sm text-red-500"
          (click)="eliminaNota(nota)"> </button>
          </div> -->
          
       
      </div>

      </ng-template>
      <ng-template pTemplate="content">
        
        <span >{{ nota.contenuto }}</span>
      </ng-template>
  </p-card>
</div>
  <div class="border-top-1 surface-border mt-2 mb-2 flex justify-center" style="justify-content: center;">
    <button [disabled]="!listaNote || listaNote.length === 0" pButton pRipple icon="pi pi-cloud-download" (click)="scaricaReportNote()" label="SCARICA" class="mt-2 mr-2 p-button-outlined font-['Poppins']" 
      style="color: #2B4162; background-color: #E9F7CA; border-color: #2B4162;"></button>
    <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" class="mt-2 p-button-outlined font-['Poppins']" 
      style="color: #2B4162; background-color: #C6D8AF; border-color: #2B4162;"></button>
  </div>
  <div>
